import React from 'react'
import { Route, Switch } from 'react-router'
import { SignIn, NotFound, AccountList, AccountEdit } from './components'
import { RedirectToReserve, Sent, SentOk } from './components/webBooks'
import Auth from './Auth'

function App() {
  return (
    <main>
      <Router />
    </main>
  )
}

const Router = () => {
  return (
    <Switch>
      <Route exact path="/" component={NotFound} />
      <Route exact path="/sent" component={Sent} />
      <Route exact path="/sentok" component={SentOk} />
      <Route exact path="/signin" component={SignIn} />
      <Route path="/webbooks/basic/:id" component={RedirectToReserve} />
      <Route path="/webbooks/album/:id" component={RedirectToReserve} />
      <Route path="/webbooks/albummd/:id" component={RedirectToReserve} />
      <Auth>
        <Switch>
          <Route exact path="/accounts" component={AccountList} />
          <Route path="/accounts/edit(/:id)?" component={AccountEdit} />
          <Route component={NotFound} />
        </Switch>
      </Auth>
      <Route component={NotFound} />
    </Switch>
  )
}

export default App
